"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/laitepalvelu/laitepalvelu.scss');
const index_1 = require("./../js/index");
const ProductsApp_laitepalvelu_1 = require("./ReactComponents/Products/ProductsApp-laitepalvelu");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)(Object.assign(Object.assign({}, index_1.DefaultComponentTypes), { ProductsApp: ProductsApp_laitepalvelu_1.default }));
// Import site specific scripts
//require("./Sites/hartwall");
